import useTranslation from 'next-translate/useTranslation'
import { useSession } from 'next-auth/react'
import styles from './PricingTable.module.scss'
import CheckboxItem from '../../molecules/Pricing/CheckboxItem'

const PricingTable = () => {
  const { data: session } = useSession()
  const { t } = useTranslation('pricing')

  const getUrl = (product: string) => {
    if (session?.accessToken?.includes('user')) {
      return `/dashboard/payments/new?${product}=1`
    }
    return `/auth/choose?target=${encodeURIComponent(
      `/dashboard/payments/new?${product}=1`
    )}`
  }

  return (
    <>
      <div className={styles['pricing-table']}>
        <div className={`${styles['pricing-table__basic']}`}>
          <div
            className={`${styles['pricing-table__header']} ${styles['pricing-table__header__big']} text-center text-raspberry-600`}
          >
            {t('basic')}
          </div>
          <div className='my-6'>
            <div className={`${styles['pricing-table__price']} text-center`}>
              {t('basicPrice')}
            </div>
            <div
              className={`${styles['pricing-table__price-subtext']} text-center`}
            >
              {t('basicPriceSub')}
            </div>
          </div>

          <a
            href={getUrl('buy_basic_offer_v2')}
            className='bg-raspberry-600 text-white w-full px-5 py-4 rounded-full inline-block text-center text-md xl:text-2xl font-thin duration-300 hover:bg-raspberry-500'
          >
            {t('basicButton')}
          </a>

          <div className='py-8'>
            <CheckboxItem
              itemKey='pricing:basicTime'
              components={[<b className='font-bold' />]}
              color='text-raspberry-600'
            />
            <CheckboxItem
              itemKey='pricing:basicBumps'
              components={[<b className='font-bold' />]}
              color='text-raspberry-600'
              explanationKey='basicBumpsExplain'
            />
            <CheckboxItem
              itemKey='pricing:basicLocations'
              components={[<b className='font-bold' />]}
              color='text-raspberry-600'
            />
          </div>
        </div>

        <div className={`${styles['pricing-table__plus']}`}>
          <div
            className={`${styles['pricing-table__header']} ${styles['pricing-table__header__big']} text-center text-action`}
          >
            {t('plus')}
          </div>
          <div className='my-6'>
            <div className={`${styles['pricing-table__price']} text-center`}>
              {t('plusPrice')}
            </div>
            <div
              className={`${styles['pricing-table__price-subtext']} text-center`}
            >
              {t('plusPriceSub')}
            </div>
          </div>

          <a
            href={getUrl('buy_plus_offer_v2')}
            className='bg-action text-white w-full px-6 py-4 rounded-full inline-block text-center text-md xl:text-2xl font-thin duration-300 hover:bg-action-500'
          >
            {t('plusButton')}
          </a>

          <div className='py-8'>
            <CheckboxItem
              itemKey='pricing:plusTime'
              components={[<b className='font-bold' />]}
              color='text-action'
            />
            <CheckboxItem
              itemKey='pricing:plusBumps'
              components={[<b className='font-bold' />]}
              color='text-action'
              explanationKey='plusBumpsExplain'
            />
            <CheckboxItem
              itemKey='pricing:plusLocations'
              components={[<b className='font-bold' />]}
              color='text-action'
            />
            <CheckboxItem
              itemKey='pricing:plusCustomerCare'
              color='text-action'
              explanationKey='plusCustomerCareExplain'
            />
            <CheckboxItem
              itemKey='pricing:plusReadme'
              color='text-action'
              explanationKey='plusReadmeExplain'
            />
          </div>
        </div>
        <div className={`${styles['pricing-table__premium']}`}>
          <div className='absolute top-0 left-0 w-full text-center text-white bg-primary rounded-t-xl'>
            Bestseller
          </div>
          <div
            className={`${styles['pricing-table__header']} ${styles['pricing-table__header__big']} text-center text-primary`}
          >
            {t('premium')}
          </div>
          <div className='my-6'>
            <div className={`${styles['pricing-table__price']} text-center`}>
              {t('premiumPrice')}
            </div>
            <div
              className={`${styles['pricing-table__price-subtext']} text-center`}
            >
              {t('premiumPriceSub')}
            </div>
          </div>

          <a
            href={getUrl('buy_premium_offer_v2')}
            className='bg-primary text-white w-full px-6 py-4 rounded-full inline-block text-center text-md xl:text-2xl font-thin duration-300 hover:bg-primary-hover'
          >
            {t('premiumButton')}
          </a>

          <div className='py-8'>
            <CheckboxItem
              itemKey='pricing:premiumTime'
              components={[<b className='font-bold' />]}
              color='text-primary'
            />
            <CheckboxItem
              itemKey='pricing:premiumBumps'
              components={[<b className='font-bold' />]}
              color='text-primary'
              explanationKey='premiumBumpsExplain'
            />
            <CheckboxItem
              itemKey='pricing:premiumLocations'
              components={[<b className='font-bold' />]}
              color='text-primary'
            />
            <CheckboxItem
              itemKey='pricing:premiumCustomerCare'
              color='text-primary'
              explanationKey='premiumCustomerCareExplain'
            />
            <CheckboxItem
              itemKey='pricing:premiumReadme'
              color='text-primary'
              explanationKey='premiumReadmeExplain'
            />
            <CheckboxItem
              itemKey='pricing:premiumSocial'
              color='text-primary'
              explanationKey='premiumSocialExplain'
            />
            <CheckboxItem
              itemKey='pricing:premiumMultiseniority'
              color='text-primary'
              explanationKey='premiumMultiseniorityExplain'
            />
            <CheckboxItem
              itemKey='pricing:premiumBanner'
              color='text-primary'
              explanationKey='premiumBannerExplain'
            />
          </div>
        </div>

        <div className={`${styles['pricing-table__superbulldog']}`}>
          <div
            className={`${styles['pricing-table__header']} ${styles['pricing-table__header__big']} text-center text-black`}
          >
            {t('super')}
          </div>
          <div className='my-6'>
            <div className={`${styles['pricing-table__price']} text-center`}>
              {t('superPrice')}
            </div>
            <div
              className={`${styles['pricing-table__price-subtext']} text-center`}
            >
              {t('superPriceSub')}
            </div>
          </div>

          <a
            href={getUrl('buy_superbulldog_offer_v2')}
            className='bg-black text-white w-full px-6 py-4 rounded-full inline-block text-center text-md xl:text-2xl font-thin duration-300 hover:bg-gray-500'
          >
            {t('superButton')}
          </a>

          <div className='py-8'>
            <CheckboxItem
              itemKey='pricing:superTime'
              components={[<b className='font-bold' />]}
              color='text-black'
            />
            <CheckboxItem
              itemKey='pricing:superBumps'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superBumpsExplain'
            />
            <CheckboxItem
              itemKey='pricing:superLocations'
              components={[<b className='font-bold' />]}
              color='text-black'
            />
            <CheckboxItem
              itemKey='pricing:superCustomerCare'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superCustomerCareExplain'
            />
            <CheckboxItem
              itemKey='pricing:superReadme'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superReadmeExplain'
            />
            <CheckboxItem
              itemKey='pricing:superCampaign'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superCampaignExplain'
            />
            <CheckboxItem
              itemKey='pricing:superMultiseniority'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superMultiseniorityExplain'
            />
            <CheckboxItem
              itemKey='pricing:superBanner'
              components={[<b className='font-bold' />]}
              color='text-black'
              explanationKey='superBannerExplain'
            />
          </div>
        </div>
      </div>

      <div className={styles['pricing-table__need-more']}>
        <div className={styles['pricing-table__side']}>
          <div className='font-bold text-4xl'>{t('needMore')}</div>

          <div className='w-full'>
            <button
              type='button'
              onClick={() => {
                document.getElementById('contact-form')?.scrollIntoView({
                  behavior: 'smooth',
                })
              }}
              className=' bg-primary text-white w-full px-6 py-4 text-lg rounded-full inline-block text-center text-xl font-thin duration-300 hover:bg-primary-hover'
            >
              {t('needMoreContact')}
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default PricingTable
